import {ZIDX, ZIDXPage} from "../../standalone/standaloneLibrary.js";
import jQuery from "jquery";
import {AIChatBox, AIChatBoxConfig} from "../../standalone/ai/AIChatBox.js";
const $ = jQuery;
export class ZIDXAccountAIFw implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountAIFwContainer";
    }
    render(){
        let self=this;

    }
}